<template>
  <el-dialog :title="'Custom date'" :visible.sync="shouldShow" width="28%">
    <el-form :model="form" label-position="top" ref="form">
      <el-row type="flex">
        <el-col :span="24">
          <el-form-item
            label="Select range"
            prop="daterange"
            :rules="inputField()"
          >
            <el-date-picker
              v-model="form.daterange"
              type="daterange"
              range-separator="-"
              start-placeholder="From"
              end-placeholder="To"
              format="dd MMM, yyyy"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button plain size="medium" @click="cancel">Cancel</el-button>
      <el-button type="primary" size="medium" @click="confirm">Apply</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RaCustomPeriod",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        daterange: []
      }
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },

  methods: {
    cancel() {
      this.shouldShow = false;
      this.$emit("cancel");
      this.form.daterange = [];
    },

    confirm() {
      this.$emit("confirm", {
        start_at: this.form.daterange[0],
        end_at: this.form.daterange[1]
      });
      this.shouldShow = false;
      this.$refs.form.resetFields();
    }
  }
};
</script>
